// Module
var code = "<div class=\"mx-widgets-panel\">\r\n\t<div ng-repeat=\"widget in vm.widgetsPanelService.widgets\" class=\"mx-widget\">\r\n\t\t<div class=\"mx-widget-content\" mx-bind-html-compile=\"widget.content\" ng-show=\"widget.visible\"></div>\r\n\t</div>\r\n</div>";
// Exports
export default code;